<template>
	<div v-if="chartOptions.series[0].data[0].name != ''" id="test2" :options="chartOptions" @click="onClickBuble">
  </div>
  <div v-else id="test2" :options="chartOptions" @click="onClickBuble">
  </div>
</template>

<script>
	import HighCharts from 'highcharts';
	import highchartsMore from 'highcharts/highcharts-more';
	highchartsMore(HighCharts);
	export default {
    props: {
      selectedTopic: null,
      selectedPeriode: null,
      selectedTopic2: null,
      statusFilter: null,
      isClickBubleOrg: null,
      isClickWord: null,
      resetcolorClicked: null,
      updateSocket: null
    },
		data() {
			return {
        isClickBuble: "",
        colorClicked: "",
				id: 'test2',
        dialog: false,
        SetPerson: [],
        chart_data_sort: [],
				chartOptions: {
					chart: {
						type: 'packedbubble',
						height: '309px'
					},
					title: {
            text: null
          },
					tooltip: {
						enabled: false
					},
					legend: {
						enabled: false
					},
					credits: {
						enabled: false
					},
          series: [
            {
              data: [{
                value: 0,
                name: '',
              }]
            },
          ],

          plotOptions: {
            packedbubble: {
              minSize: '40%',
              maxSize: '120%',
              zMin: 0,
              zMax: 1000,
              layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.02
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}',
                useHTML: true,
                style: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  width: 100,
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                },
              }
            }
          },
				},
			}
		},
		mounted() {
      HighCharts.chart(this.id, this.chartOptions);
    },
		updated() {
			HighCharts.chart(this.id, this.chartOptions);
		},
    methods: {
      onClickBuble(event) {
        // alert('aaa')
        this.isClickBuble = event.point.name;
        console.log(event.point.color);
        this.colorClicked = event.point.color;
        this.$emit('bubble-clicked', this.isClickBuble); 
      },
      async generatebubble() {
        this.MediatwitterShare = [];
        if (this.updateSocket == false) {
          this.dialog = true;
        }
        // try {
            const data = this.$store.bubble_data;
            const person = [];
            const person2 = [];
            data.data_bubble.forEach((element) => {
              if (element["name"] != '' && element["name"] != null) {
                person.push(element["name"]);
                person2.push(element["name"]);
              }
            });

            this.SetPerson = [...new Set(person)];
            this.chart_data_sort = [];
            for (let x = 0; x < this.SetPerson.length; x++) {
              this.chart_data_sort.push({
                'name_organization' : this.SetPerson[x],
                'name_organization_value' : data.data_bubble[x].totalNews
              })
            }
            this.chart_data_sort.sort(function(a,b) { // sort desc value
              return (b.name_organization_value) - (a.name_organization_value);
            });
            this.chartOptions.series = Array.from({ length: Math.max(6, this.chart_data_sort.length) }, () => ({
              data: [{ value: 0, name: '' }]
            }));
            // if (this.SetPerson.length == 0) {
              for (let i = 0; i < 6; i++) {
                this.chartOptions.series[i].data[0].name = "";
                this.chartOptions.series[i].data[0].value = 0;
                // this.chartOptions.series[i].data[0].color = '';
              }
            // }
            // hidden 
            if (this.SetPerson.length != 0) {
              for (let x = 0; x < this.chart_data_sort.length; x++) {
                if (this.chartOptions.series[x]) {
                  if (x < 6) {
                    this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_organization;
                    this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_organization_value);
                  }
                }
              }
            }
            this.chartOptions.series = this.chartOptions.series.filter(
              seriesItem => seriesItem.data[0].name !== ""
            );
            // end hidden 
            // console.log(this.chartOptions.series);
            
            window.dispatchEvent(new Event('resize'))
          // this.dialog = false;
        // } catch(e) {
        //   this.dialog = false;
        //   console.log('error');
        //   console.log(e);
        // }
      },
    },
	};
</script>